export default (function () {
  // Header Menu
  $('.header .box-btn').click(function () {
    $('body').toggleClass('open-nav');
  });
  $('.header-shop .box-btn').click(function () {
    $('body').toggleClass('open-nav-shop');
  });
  $('.nav > li.menu-item-has-children').append('<i class="icon-chevron"></i>');
  $('.nav > li.current-menu-item').addClass('open-sub-menu');
  $('.nav > li.menu-item-has-children > i.icon-chevron').on('click', function () {
    $(this).parent().toggleClass('open-sub-menu');
    $(this).parent().siblings().removeClass('open-sub-menu');
  });
  $('.nav > li > .sub-menu > li.current-menu-parent').parent().addClass('has-current-menu-parent');
  $('.header-nav-bg').click(function () {
    $('body').removeClass('open-nav');
  }); // Arrow Scroll Top

  $('.btn-scroll-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  }); // Action with list-books-menu

  $('.textmarker').on('click', function (e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('#penbutton').remove();
      $('#postContent').removeClass('highL');
    } else {
      $(this).addClass('active');
      $('#postContent').addClass('highL');
      selectext();
    }

    $('.box-books-menu').removeClass('open-books-menu');
  }); // Accordion

  $('.accordion').accordion({
    collapsible: true,
    header: '.accordion-header',
    heightStyle: 'content',
    icons: false
  });
  var activeIndex = false;

  if ($('.user-directory').length && $('.directory-active').length) {
    activeIndex = $('.accordion-inner').find('.directory-active').index();
  }

  $('.accordion-inner').accordion({
    collapsible: true,
    header: '.accordion-inner-header',
    heightStyle: 'content',
    icons: false,
    active: activeIndex
  }); // Block Actions

  $('.box-icons').on('click keydown', function (e) {
    e.stopPropagation();
  });
  $('.block-list-item > .box-icons > .icon-ellipsis').click(function (e) {
    $(this).closest('.block-list-item').toggleClass('open-actions');
    $('.block-list-item').not($(this).closest('.block-list-item')).removeClass('open-actions');
  });
  $(document).on('click', function (e) {
    var $trigger = $('.box-actions, .box-books-menu');

    if ($trigger !== e.target && !$trigger.has(e.target).length) {
      $('.block-list-item, .table-list-item').removeClass('open-actions'); //$('.box-books-menu').removeClass('open-books-menu').removeClass('open-accordion-menu');

      $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
      $('.block-list-sortable').sortable('disable');
    }
  });
  $('.box-actions-bg, .list-books-menu-bg').click(function (e) {
    $('.block-list-item, .table-list-item').removeClass('open-actions');
    $('.box-books-menu').removeClass('open-books-menu').removeClass('open-accordion-menu');
    $('.block-list-sortable').find('.block-list-item').addClass('not-sortable').find('.box-actions-item').removeClass('active');
    $('.block-list-sortable').sortable('disable');
  });
  $('.box-title .icon-pen').click(function () {
    $(this).closest('.box-title').addClass('edit-title').find('.title-input').focus().select();
    $(this).closest('.box-title').next('.box-subtitle').addClass('edit-subtitle');
  });
  $('.box-new-list input[type="checkbox"]').click(function () {
    if ($(this).is(':checked')) {
      $(this).closest('.box-new-list').addClass('edit-new-list').find('.new-list-input').focus().select();
    } else {
      $(this).closest('.box-new-list').removeClass('edit-new-list');
    }
  });
  $('.table-list-item-head input[type="checkbox"]').click(function () {
    if ($(this).is(':checked')) {
      $(this).closest('.table-list').find('.table-list-item:not(.table-list-item-head) input[type="checkbox"]').prop('checked', true);
    } else {
      $(this).closest('.table-list').find('.table-list-item:not(.table-list-item-head) input[type="checkbox"]').prop('checked', false);
    }
  });
  $('.table-list-item .icon-ellipsis').click(function (e) {
    $(this).closest('.table-list-item').toggleClass('open-actions');
    $('.table-list-item').not($(this).closest('.table-list-item')).removeClass('open-actions');
  }); // Accordion List

  $('.accordion-list-content').hide();
  $('.accordion-list-caption.active ~ .accordion-list-content').show();
  $('.accordion-list-caption').click(function () {
    $(this).next().slideToggle(300);
    $('.accordion-list-content').not($(this).next()).slideUp(300);
    $(this).toggleClass('active');
    $('.accordion-list-caption').not($(this)).removeClass('active');
  }); // Block More

  $('.block-list').each(function () {
    $(this).find('> div').each(function (num) {
      if (num >= 3) {
        $(this).addClass('block-list-item-hidden');
        $(this).parent().next('.block-more').show();
      }
    });
  });
  $('.block-more .btn').click(function (e) {
    e.preventDefault();
    $(this).closest('.block-more').prev().find('.block-list-item-hidden').removeClass('block-list-item-hidden');
    $(this).closest('.block-more').hide();
  });

  if (activeIndex > 2) {
    $('.block-more .btn').click();
  } // Sortable


  $('.block-list-sortable').sortable({
    connectWith: '.block-list-sortable',
    cancel: '.not-sortable',
    cursor: 'move',
    disabled: true
  });
  $('.table-list-sortable').sortable({
    connectWith: '.table-list-sortable',
    items: '.table-list-item:not(.table-list-item-head)',
    cursor: 'move'
  }); // Books Menu Bar

  $('.btn-books-menu').click(function (e) {
    $(this).parent().toggleClass('open-books-menu').removeClass('open-accordion-menu');
  }); // Block Video

  $('.box-video').click(function () {
    var $this = $(this);
    $this.find('.box-video-overlay').hide();

    if ($this.find('.box-video-media-youtube')[0]) {
      $this.find('.box-video-media-youtube')[0].src += '?muted=1&autoplay=1';
    }

    if ($this.find('.box-video-media-vimeo')[0]) {
      $this.find('.box-video-media-vimeo')[0].src += '?mute=1&autoplay=1';
    }

    setTimeout(function () {
      $this.find('.box-video-media').show();
    }, 200);
  }); // Tooltip

  $('.tooltip').tooltip({
    position: {
      my: 'left bottom',
      at: 'right bottom-100%'
    }
  }); // Custom Select

  $('#select-anrede').customSelect({
    placeholder: 'Anrede'
  });
  $('#select-titel').customSelect({
    placeholder: 'Titel'
  });
  $('.form-group select, .quantity select').customSelect(); // Form Label Animation

  $(document).on('blur input', '.form-control, .woocommerce input.input-text, .woocommerce textarea', function () {
    var $field = $(this).closest('.form-control-wrap, .form-row');

    if (this.value) {
      $field.addClass('filled');
      $field.addClass('focused');
    } else {
      $field.removeClass('filled');
      $field.removeClass('focused');
    }
  });
  $(document).on('focus input', '.form-control, .woocommerce input.input-text, .woocommerce textarea', function () {
    var $field = $(this).closest('.form-control-wrap, .form-row');

    if (this) {
      $field.addClass('focused');
    } else {
      $field.removeClass('focused');
    }
  });
  $('.form-control, .woocommerce input.input-text, .woocommerce textarea').each(function () {
    var $field = $(this).closest('.form-control-wrap, .form-row');

    if (this.value) {
      $field.addClass('filled');
      $field.addClass('focused');
    } else {
      $field.removeClass('filled');
      $field.removeClass('focused');
    }
  });
  $('.woocommerce .form-row').find('select').closest('.form-row').addClass('form-row-select');
  $('.woocommerce .form-row').find('.button').closest('.form-row').addClass('form-row-button'); // Bionic

  $('#u_bionic').on('click', function () {
    if ($(this).attr('value') === '1') {
      $(this).removeAttr('value');
      $(this).removeAttr('checked');
    } else {
      $(this).attr('value', '1');
      $(this).prop('checked', true);
    }
  }); // File Drop Upload

  var $fileInput = $('.file-input');
  var $droparea = $('.file-drop-upload');
  $(document).on('dragenter focus click', '.file-input', function () {
    $('.file-drop-upload').addClass('active');
  });
  $(document).on('dragleave blur drop', '.file-input', function () {
    $('.file-drop-upload').removeClass('active');
  });
  $(document).on('change', '.file-input', function () {
    var filesCount = $(this)[0].files.length;
    var $textContainer = $(this).prev();

    if (filesCount === 1) {
      var fileName = $(this).val().split('\\').pop();
      $textContainer.text(fileName);
    } else {
      $textContainer.text(filesCount + ' dateien ausgewählt');
    }
  }); // Tabs tashchebucher

  if ($('.content-books .tabs-category-in a.active').length == 0) {
    $('.content-books .tabs-category-in a:nth-child(1)').addClass('active');
  } // Open pop-up in search page


  $('.open-search-popup').on('click', function (e) {
    e.preventDefault();
    $('.search-popup').toggleClass('open-popup');
  }); // Accordion Menu

  $('.js-notes').click(function (e) {
    e.preventDefault();
    $(this).closest('.box-books-menu').addClass('open-accordion-menu').removeClass('open-books-menu');
    var activeMenuIndex = $('.accordion-menu').find('.accordion-menu-item-notes').index();
    $('.accordion-menu').accordion({
      collapsible: true,
      header: '.accordion-menu-header',
      heightStyle: 'content',
      icons: false,
      active: activeMenuIndex
    });
  });
  $('.js-markings').click(function (e) {
    e.preventDefault();
    $(this).closest('.box-books-menu').addClass('open-accordion-menu').removeClass('open-books-menu');
    var activeMenuIndex = $('.accordion-menu').find('.accordion-menu-item-markings').index();
    $('.accordion-menu').accordion({
      collapsible: true,
      header: '.accordion-menu-header',
      heightStyle: 'content',
      icons: false,
      active: activeMenuIndex
    });
  });
  $('.accordion-menu-inner').accordion({
    collapsible: true,
    header: '.accordion-menu-inner-header',
    heightStyle: 'content',
    icons: false,
    active: false
  }); // Login

  $('.js-login').click(function (e) {
    e.preventDefault();
    $('body').addClass('open-login');
  });
  $('.js-forgot-password').click(function (e) {
    e.preventDefault();
    $('body').addClass('open-reset-password').removeClass('open-login');
  });
  $('.block-login-bg').click(function () {
    $('body').removeClass('open-login').removeClass('open-reset-password');
  });
  $("#loginform").on('submit', function (e) {
    e.preventDefault();
    var action_url = $('#loginform').attr('action');
    var input_data = $('#loginform').serialize();
    var logout_url = $('#loginform input[name="logout_url"]').val();
    var crispwp_ajax_url = crispwp_params.crispwp_ajax_url;
    $.ajax({
      type: "POST",
      timeout: "5000",
      url: action_url,
      data: input_data,
      success: function success(response, textStatus, xhr) {
        if (xhr.status === 200) {
          if (response) {
            if (response) {
              $('.popup-login .block-login__status').hide();
              $.ajax({
                type: 'POST',
                url: crispwp_ajax_url,
                data: {
                  action: 'check_user_login'
                },
                success: function success(re) {
                  console.log(re);

                  if (re) {
                    $('.popup-login .block-login__status').hide();
                    location.reload();
                  } else {
                    $('.popup-login .block-login__status').show();
                  }
                },
                error: function error(xhr, textStatus, errorThrown) {
                  console.log(xhr);
                  $('.popup-login .block-login__status').show();
                }
              });
            } else {
              $('.popup-login .block-login__status').show();
            }
          } else {
            $('.popup-login .block-login__status').show();
          }
        } else {
          $('.popup-login .block-login__status').show();
        }
      }
    });
    return false;
  });
  $("#reset_password").on('submit', function (e) {
    e.preventDefault();
    var action_url = $('#reset_password').attr('action');
    var input_data = $('#reset_password').serialize();
    $.ajax({
      type: "POST",
      timeout: "5000",
      url: action_url,
      data: input_data,
      success: function success(msg) {
        var reg1 = /login_error/g;

        if (reg1.test(msg)) {
          $('.popup-reset-password .block-login__status.status-error').show();
          $('.popup-reset-password .block-login__status.status-success').hide();
        } else {
          $('.popup-reset-password .block-login__status.status-success').show();
          $('.popup-reset-password .block-login__status.status-error').hide();
        }
      }
    });
    return false;
  }); // Slider Digibooks

  $('.slider-digibooks').slick({
    slidesToShow: 20,
    slidesToScroll: 20,
    dots: false,
    arrows: false,
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><i class='icon icon-arrow-slim'></i></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><i class='icon icon-arrow-slim'></i></button>",
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: true
      }
    }, {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }]
  }); // Digibook Smooth Scroll

  $('.anchor-digibook').on('click', function (e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $($.attr(this, "href")).offset().top
    }, 500);
  });

  if (window.location.hash && window.location.hash.indexOf('product-') > -1 && $('[data-product="' + window.location.hash.replace('#', '') + '"]').length) {
    $("html, body").animate({
      scrollTop: $('[data-product="' + window.location.hash.replace('#', '') + '"]').offset().top - $('.header-shop').innerHeight() - 40
    }, 500);
  } // Accordion Digibook


  $('.accordion-digibook').accordion({
    collapsible: true,
    header: '.accordion-digibook-header',
    heightStyle: 'content',
    icons: false,
    active: false
  }); // Popup Confirmation

  $('.js-unlock-another-digibook').click(function (e) {
    e.preventDefault();
    $(this).closest('.block-popup-confirmation').removeClass('open-popup');
  }); // Registration form validate

  $('.registration input[type=password]').keyup(function () {
    var pswd = $(this).val(); //validate the length

    if (pswd.length < 8) {
      $('#pswd_info').addClass('goodpass');
      $('#pswd_info').css('opacity', '0');
    } else {
      $('#pswd_info').removeClass('goodpass');
      $('#pswd_info').css('opacity', '1');
    } //validate letter


    if (pswd.match(/[A-z]/)) {
      $('#pswd_info').addClass('goodpass');
      $('#pswd_info').css('opacity', '0');
    } else {
      $('#pswd_info').removeClass('goodpass');
      $('#pswd_info').css('opacity', '1');
    } //validate capital letter


    if (pswd.match(/[A-Z]/)) {
      $('#pswd_info').addClass('goodpass');
      $('#pswd_info').css('opacity', '0');
    } else {
      $('#pswd_info').removeClass('goodpass');
      $('#pswd_info').css('opacity', '1');
    } //validate number


    if (pswd.match(/[0-9]/)) {
      $('#pswd_info').addClass('goodpass');
      $('#pswd_info').css('opacity', '0');
    } else {
      $('#pswd_info').removeClass('goodpass');
      $('#pswd_info').css('opacity', '1');
    }
  });
  $('#regform').on('submit', function (event) {
    event.preventDefault();
    var alertpass = $(this).find('input[name="alertpass"]').val();
    var u_password_confirm = $(this).find('input[name="u_password_confirm"]').val();
    var user_pass = $(this).find('input[name="user_pass"]').val();

    if ($('#pswd_info').hasClass('goodpass')) {
      if (u_password_confirm == user_pass) {
        var crispwp_ajax_url = crispwp_params.crispwp_ajax_url;
        var user_login = $(this).find('[name="user_login"]').val();
        var first_name = $(this).find('[name="first_name"]').val();
        var last_name = $(this).find('[name="last_name"]').val();
        var user_email = $(this).find('[name="user_email"]').val();

        var _user_pass = $(this).find('[name="user_pass"]').val();

        var phone = $(this).find('[name="phone"]').val();
        var anrede = $(this).find('[name="anrede"]').val();
        var titel = $(this).find('[name="titel"]').val();
        var vb_new_user_nonce = $(this).find('[name="vb_new_user_nonce"]').val();
        var wp_http_referer = $(this).find('[name="_wp_http_referer"]').val();
        $.ajax({
          type: 'POST',
          url: crispwp_ajax_url,
          data: {
            action: 'crispwp_regist',
            user_login: user_login,
            first_name: first_name,
            last_name: last_name,
            user_email: user_email,
            user_pass: _user_pass,
            phone: phone,
            anrede: anrede,
            titel: titel,
            vb_new_user_nonce: vb_new_user_nonce,
            _wp_http_referer: wp_http_referer
          },
          beforeSend: function beforeSend(xhr) {
            $('#loading').addClass('show-preloader');
          },
          success: function success(data) {
            if (data == '1') {
              location.href = '/email-confirmation/?required=true';
            } else {
              alert(data);
              $('#loading').removeClass('show-preloader');
            }
          },
          error: function error() {
            alert('Error, please try again later');
            $('#loading').removeClass('show-preloader');
          }
        });
        return false;
      } else {
        alert(alertpass);
      }
    }
  });
  document.addEventListener('invalid', function (e) {
    $(e.target).addClass("invalid");
    $('html, body').animate({
      scrollTop: $($(".invalid")[0]).offset().top - 150
    }, 0);
  }, true);
  document.addEventListener('change', function (e) {
    $(e.target).removeClass("invalid");
  }, true);
  $('.useravatar .file-input').on('change', function (event) {
    checkFileSize(event);
  });

  function checkFileSize(event) {
    var fileInput = event.target;
    var file = fileInput.files[0];

    if (file.size > 2 * 1024 * 1024) {
      var alertMessage = fileInput.getAttribute("data-alert");
      alert(alertMessage);
      fileInput.value = "";
    } else {
      previewAvatar(event);
    }
  }

  function previewAvatar(event) {
    var input = event.target;
    console.log(input);
    var reader = new FileReader();

    reader.onload = function () {
      var preview = document.getElementById('avatarpreview');
      preview.src = reader.result;
      preview.style.display = 'block';
    };

    reader.readAsDataURL(input.files[0]);
  }

  $('.useravatar .remove').on('click', function () {
    var crispwp_ajax_url = crispwp_params.crispwp_ajax_url;
    var data = {
      action: 'remove_user_avatar'
    };
    $.ajax({
      type: 'POST',
      url: crispwp_ajax_url,
      data: data,
      beforeSend: function beforeSend(xhr) {
        $('#loading').addClass('show-preloader');
      },
      success: function success(response) {
        $urlimg = 'https://secure.gravatar.com/avatar/a75077fac10227714c3511e59dd3d2aa?s=298&d=mm&r=g';
        $('.useravatar-current img').attr('src', $urlimg).attr('srcset', $urlimg);
        $('#loading').removeClass('show-preloader');
      },
      error: function error(xhr, status, _error) {
        console.error(_error);
        $('#loading').removeClass('show-preloader');
      }
    });
  });

  if ($('.emailConfirmationCount').length > 0) {
    var countdown = function countdown() {
      counterElement.text(count--);

      if (count >= 0) {
        setTimeout(countdown, 1000);
      } else {
        window.location.href = '/meine-taschenbuecher/';
      }
    };

    var counterElement = $('.counter');
    var count = 5;
    countdown();
  }

  $('.product-optional input.qty').on('keyup', function () {
    var theid = $(this).parent('.quantity').data('prod');
    var thisParentID = $(this).closest('.product-optional').data('parent');
    var productParent = $('.products').find('[data-product="' + thisParentID + '"]');
    var productParentQuantity = $(productParent).find('input.qty').val();
    var thisQuantity = $(this).val();
    var lastCount = productParentQuantity - thisQuantity;

    if (lastCount < 1) {
      lastCount = 0;
    }

    $('[data-parent="' + thisParentID + '"]').each(function () {
      if (!$(this).hasClass('post-' + theid)) {
        if ($(this).find('input.qty').val() > lastCount) {
          $(this).find('input.qty').attr('max', lastCount);
          $(this).find('input.qty').val(lastCount);
        }
      }
    });
  });
});